import React from 'react';
import { Star } from 'lucide-react';

const reviews = [
  {
    id: 1,
    name: 'Garth Bothma',
    rating: 5,
    date: '22 hours ago',
    text: "Ethan and his team delivered truly professional service. They arrived on time, completed the air-conditioning servicing neatly, and worked with great attention to detail. The whole experience was smooth, efficient, and all-round professional. Highly recommended!",
    avatar: 'GB',
    badge: 'Local Guide',
  },
  {
    id: 2,
    name: 'Steve Burns',
    rating: 5,
    date: '1 week ago',
    text: "It's so refreshing to see the level of service that this business provides. Ethan has done a fair amount of work on my equipment and his knowledge and fault finding skills are outstanding. His prompt and efficient service has saved us during a particularly hot summer and I have no hesitation in recommending him as a highly skilled and efficient service provider, who has a very good attitude and his customers best interests at heart. I will definitely be using him exclusively for any future issues or services of my equipment.",
    avatar: 'SB',
    badge: 'Local Guide',
  },
  {
    id: 3,
    name: 'Christi Burns',
    rating: 5,
    date: '1 week ago',
    text: "Exceptional service on numerous occasions by Ethan. He is extremely reliable and knows exactly what he's doing. He is prompt with finding the closest appointment to the enquiry, has an amazing attitude and work ethic. I highly highly recommend and will refer him to anyone confidently",
    avatar: 'CB',
  },
  {
    id: 4,
    name: 'Spencer Kallie',
    rating: 5,
    date: '6 weeks ago',
    text: 'Professional service and great results. Highly recommend Chill Point for all your air conditioning needs!',
    avatar: 'SK',
  },
  {
    id: 5,
    name: 'Lauren Coppin',
    rating: 5,
    date: '6 weeks ago',
    text: 'Ethan was fast, responsive and fixed my AC issue in record time even though several parts needed replacing. Highly recommended!',
    avatar: 'LC',
  },
];

const renderStars = (rating) => (
  <div className="flex">
    {[...Array(5)].map((_, i) => (
      <Star key={i} className={`w-4 h-4 ${i < rating ? 'fill-yellow-400 text-yellow-400' : 'text-gray-600'}`} />
    ))}
  </div>
);

const GoogleReviews = () => {
  return (
    <div className="w-full" data-testid="google-reviews">
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center space-x-6">
          <div className="text-center">
            <div className="text-5xl font-bold text-white">5.0</div>
            <div className="mt-2">{renderStars(5)}</div>
            <p className="text-sm text-gray-400 mt-2">Based on {reviews.length} reviews</p>
          </div>
          <div className="flex items-center space-x-2">
            <img
              src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png"
              alt="Google"
              className="h-5 brightness-0 invert opacity-60"
            />
            <span className="text-sm text-gray-500">Reviews</span>
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {reviews.map((review) => (
          <div key={review.id} className="bg-white/5 border border-white/10 rounded-xl p-6 hover:border-[#00D9FF]/20 transition-all duration-300" data-testid={`review-${review.id}`}>
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-gradient-to-br from-[#0066FF] to-[#00D9FF] text-white rounded-full flex items-center justify-center font-semibold text-sm">
                  {review.avatar}
                </div>
                <div>
                  <p className="font-semibold text-white text-sm">{review.name}</p>
                  {review.badge && <p className="text-xs text-[#00D9FF] font-medium">{review.badge}</p>}
                  <p className="text-xs text-gray-500">{review.date}</p>
                </div>
              </div>
              {renderStars(review.rating)}
            </div>
            <p className="text-gray-400 leading-relaxed text-sm">{review.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GoogleReviews;
